(function ($) {
    "use strict";

    const carouselSliders = $('.carousel');

    $(carouselSliders).each(function (e) {
        var currentCarousel = $(this);
        var currentCarouselId = $(currentCarousel).attr('id');
        var currentCarouselIdSelector = '#' + currentCarouselId;

        $(currentCarouselIdSelector + ' .next-slide').click(function () {
            $(currentCarouselIdSelector + '.carousel').carousel('next');
            return false;
        });

        $(currentCarouselIdSelector + ' .prev-slide').click(function () {
            $(currentCarouselIdSelector + '.carousel').carousel('prev');
            return false;
        });

        if (currentCarousel.hasClass('slide-carousel')) {
            var carouselItems = $(currentCarouselIdSelector + ' .carousel-item');
            var carouselItemsLenght = $(carouselItems).length;
            if (carouselItemsLenght <= 3) {
                $(currentCarousel).carousel({
                    interval: false
                });
            }

            $(currentCarouselIdSelector).on("slide.bs.carousel", function (e) {
                var $e = $(e.relatedTarget);
                var idx = $e.index();
                var itemsPerSlide = 3;
                var totalItemsCount = $(currentCarouselIdSelector + ' .carousel-item').length;
                if (idx >= totalItemsCount - (itemsPerSlide - 1)) {
                    var it = itemsPerSlide - (totalItemsCount - idx);
                    for (var i = 0; i < it; i++) {
                        if (e.direction == "left") {
                            $(currentCarouselIdSelector + ' .carousel-item').eq(i).appendTo(currentCarouselIdSelector + ' .carousel-inner');
                        } else {
                            $(currentCarouselIdSelector + ' .carousel-item').eq(0).appendTo(currentCarouselIdSelector + ' .carousel-inner');
                        }
                    }
                }
            });
        }
    });
})(jQuery);

